// extracted by LIB_CSS_EXTRACT_LOADER
import "./spinner_module.css"
export default {"spinner":"spinner-R6WX_P","spin":"spin-q0qyGs","track":"track-yVCPfY","indicator":"indicator-fZm2Rm"};